document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('slideshow-component').forEach((slideshow) => {
    const slides = slideshow.querySelectorAll('.slideshow__slide');
    const nextBtn = slideshow.querySelector('.slider-button--next');
    const prevBtn = slideshow.querySelector('.slider-button--prev');
    let currentIndex = 0;

    function showSlide(index) {
      slides.forEach(slide => slide.removeAttribute('aria-hidden'));
      slides.forEach(slide => slide.classList.remove('slider__slide--active'));

      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      slides[index].setAttribute('aria-hidden', 'false');
      slides[index].classList.add('slider__slide--active');
      currentIndex = index;
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        showSlide(currentIndex + 1);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        showSlide(currentIndex - 1);
      });
    }

    // Optional: auto-rotate functionality
    const autoRotate = slideshow.dataset.autoplay === 'true';
    const speed = parseInt(slideshow.dataset.speed || 5000);

    if (autoRotate) {
      setInterval(() => {
        showSlide(currentIndex + 1);
      }, speed);
    }

    // Initialize
    showSlide(currentIndex);
  });
});
